import { Text } from "@jsq/ds/core";

export type StatusTextProps = {
  primaryText: string;
  color?: string;
  paddingTop?: number | string;
};

export const StatusTextBlock = ({ primaryText, color, paddingTop }: StatusTextProps) => (
  <Text
    data-testid="case-status-label"
    data-cy="case-status-label"
    style={{ paddingTop, color }}
    marginBottom="xs"
  >
    {primaryText}
  </Text>
);

export default StatusTextBlock;
